import { render, staticRenderFns } from "./SendCommentPage.vue?vue&type=template&id=9e51d73a&"
import script from "./SendCommentPage.vue?vue&type=script&lang=js&"
export * from "./SendCommentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports